import { render, staticRenderFns } from "./peisxz.vue?vue&type=template&id=3e63b983&scoped=true&"
import script from "./peisxz.vue?vue&type=script&lang=js&"
export * from "./peisxz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e63b983",
  null
  
)

export default component.exports